import { ContextOrganizationFieldMode } from "components/ContextOrganizationField";
import useBoolean from "hooks/useBoolean";
import MediaLibraryItemCreateForm from "pages/MediaLibraryPage/MediaLibraryItemCreateForm";
import MediaLibraryItemsListView from "pages/MediaLibraryPage/MediaLibraryItemsListView";
import { IMediaItem, MediaItemSource } from "services/KnowfullyAdminClient";
import { MediaFilterType } from "utils/mediaUtils";

type MediaLibraryDialogViewProps = {
  source?: MediaItemSource;
  options: MediaFilterType[];
  customBackButtonLabel?: string;
  alternativeTextRequired?: boolean;
  customAlternativeTextLabel?: string;
  organizationPickerMode?: ContextOrganizationFieldMode;
  organizationIdOverride?: string;
  maxFileSizeBytes?: number;
  onClickMediaLibraryItem: (mediaLibraryItem: IMediaItem) => void;
  getItemLabel?: (item: IMediaItem) => string;
};

export const MediaLibraryDialogView = ({
  source = MediaItemSource.MediaLibrary,
  options,
  customBackButtonLabel,
  alternativeTextRequired,
  customAlternativeTextLabel,
  organizationPickerMode,
  organizationIdOverride,
  maxFileSizeBytes,
  onClickMediaLibraryItem,
  getItemLabel,
}: MediaLibraryDialogViewProps) => {
  const [isCreation, setIsCreation] = useBoolean(false);

  const onClickCreateMediaLibraryItem = () => {
    setIsCreation.setTrue();
  };

  return isCreation ? (
    <MediaLibraryItemCreateForm
      source={source}
      options={options}
      customBackButtonLabel={customBackButtonLabel}
      alternativeTextRequired={alternativeTextRequired}
      customAlternativeTextLabel={customAlternativeTextLabel}
      organizationPickerMode={organizationPickerMode}
      organizationIdOverride={organizationIdOverride}
      maxFileSizeBytes={maxFileSizeBytes}
      onRedirectBack={setIsCreation.setFalse}
    />
  ) : (
    <MediaLibraryItemsListView
      source={source}
      options={options}
      onClickCreateMediaLibraryItem={onClickCreateMediaLibraryItem}
      onClickMediaLibraryItem={onClickMediaLibraryItem}
      getItemLabel={getItemLabel}
    />
  );
};
